import Hero from './Components/Welcome/Hero'
import AuthorityBuilders from './Components/Welcome/AuthorityBuilders'
import FeaturedClients from './Components/Welcome/FeaturedClients'
import ImpactGrid from './Components/Welcome/ImpactGrid'
import GrowthTools from './Components/Welcome/GrowthTools'
import MapFuture from './Components/Welcome/MapFuture'
import HomeMetrics from './Components/Welcome/HomeMetrics'
import Tiers from './Components/Pricing/Tiers'
import CTA from './Components/CTA'

const Welcome = () => {
  return (
    <div id="wrapper" className='select-none'>

      <Hero></Hero>

      <AuthorityBuilders></AuthorityBuilders>

      <FeaturedClients></FeaturedClients>

      <ImpactGrid></ImpactGrid>

      <GrowthTools></GrowthTools>

      <MapFuture></MapFuture>

      <HomeMetrics></HomeMetrics>

      <Tiers></Tiers>

      <CTA></CTA>

    </div>
  )
}



export default Welcome;
